export default __webpack_public_path__ + "static/media/adminEdit.6c262818.svg";